<template>
    <div id="create-library-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Add Library</h1>
                <LibraryForm @formSubmitted="createLibrary" />
            </section>
        </div>
    </div>
</template>

<script>
import LibraryForm from '@/components/forms/LibraryForm.vue'

const endpoint = process.env.VUE_APP_API_BASE + '/libraries/create'
import axios from 'axios'

export default {
    name: 'LibrariesCreate',
    components: {
        LibraryForm
    },
    data: function() {
        return {

        }
    },
    methods: {
        createLibrary(fd) {
            axios.post(endpoint, fd)
                  .then(response => {
                      console.log(response)
                      alert('Library created successfully')
                      this.$router.push('/libraries')
                  })
                  .catch(error => {
                      console.log(error.response)
                      if (error.response && error.response.data?.data) {
                          alert(error.response.data.data)
                      }
                      else {
                          alert('Error occurred!')
                          console.log(error)
                      }
                  })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
